import Icon from '../components/Icon.vue'

Icon.register({"home":{"width":1664,"height":1792,"paths":[{"d":"M1408 992v480q0 26-19 45t-45 19h-384v-384h-256v384h-384q-26 0-45-19t-19-45v-480q0-1 0.5-3t0.5-3l575-474 575 474q1 2 1 6zM1631 923l-62 74q-8 9-21 11h-3q-13 0-21-7l-692-577-692 577q-12 8-24 7-13-2-21-11l-62-74q-8-10-7-23.5t11-21.5l719-599q32-26 76-26t76 26l244 204v-195q0-14 9-23t23-9h192q14 0 23 9t9 23v408l219 182q10 8 11 21.5t-7 23.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/home.js
// module id = 8AWp
// module chunks = 1